// DATA
export const getPersonaLibraryData = state => state.personaLibrary.get('data')
export const getPersonas = state => getPersonaLibraryData(state).get('personas')

// UI
export const getPersonaLibraryUi = state => state.personaLibrary.get('ui')
export const getPersonaDialogOpen = state => getPersonaLibraryUi(state).get('personaDialogOpen')
export const getSelectedPersona = state => getPersonaLibraryUi(state).get('selectedPersona')
export const getPersonaLibraryRequestRunning = state => getPersonaLibraryUi(state).get('requestRunning')
